var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.5C2.9625 0.5 0.5 2.9625 0.5 6C0.5 9.0375 6 16.5 6 16.5C6 16.5 11.5 9.0375 11.5 6C11.5 2.9625 9.0375 0.5 6 0.5ZM6 9.5C4.06562 9.5 2.5 7.93437 2.5 6C2.5 4.06562 4.06562 2.5 6 2.5C7.93437 2.5 9.5 4.06562 9.5 6C9.5 7.93437 7.93437 9.5 6 9.5ZM6 7.5C6.82812 7.5 7.5 6.82812 7.5 6C7.5 5.17188 6.82812 4.5 6 4.5C5.17188 4.5 4.5 5.17188 4.5 6C4.5 6.82812 5.17188 7.5 6 7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsIcon);
export default __webpack_public_path__ + "static/media/locationsIcon.9feba5642524b3a7b7930a31ec79460b.svg";
export { ForwardRef as ReactComponent };